@include section-styles(0px, 0px);

section {
  max-width: 100vw;
}

:host(:focus) {
  outline: none !important;
}

@include container-deprecated('.section-inner');

.section-inner {
  position: relative;

  .loader-wrapper {
    display: none;
    justify-content: center;
  }

  .error-wrapper {
    @include error-wrapper(var(--color-grey-blue), var(--font-color-main));

    display: none;
    font-size: var(--font-size-m);
    padding: 2rem;
    margin-top: 20px;

    p {
      font-size: var(--font-size-main-text);
      text-align: left;
      margin: 5px 0 20px 0;
    }

    .error-headline {
      font-size: var(--font-size-sm);
      margin: 0;
    }

    .resetButton {
      margin: 0 auto;
      max-width: fit-content;
    }
  }

  .map-wrapper {
    height: 0;
    position: relative;
    @include map-wrapper;
  }

  @include media-max-width($breakpoint-m) {
    .show-map {
      .map-wrapper {
        height: 300px;

        .map-canvas {
          height: 300px;
        }
      }
    }
  }

  &.loading {
    .loader-wrapper {
      display: flex;
    }
    .form-container {
      display: none;
    }
    .map-wrapper {
      display: none;
    }
    .content {
      display: none;
    }
  }

  &.error {
    .error-wrapper {
      display: flex;
    }
    .form-container {
      display: none;
    }
    .map-wrapper {
      display: none;
    }
    .content {
      display: none;
    }
    .more {
      display: none;
    }
  }

  &.no-results {
    .error-wrapper {
      display: flex;
    }
    .form-container {
      display: flex;
    }
    .content {
      display: none;
    }
    .more {
      display: none;
    }
  }

  form {
    display: flex;
    z-index: 1;
    width: 100%;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    -webkit-transition-duration: 0.75s;
    transition-duration: 0.75s;
    -webkit-transition-property: width, margin-left, margin-right;
    transition-property: width, margin-left, margin-right;
  }

  .show-map {
    .map-wrapper {
      height: 360px;
    }
/*
    form {
      width: 80%;
      margin-top: -65px;
    }

 */
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;
  }
}

.more {
  display: flex;
  justify-content: center;
  padding-top: 2rem;
}

.form-container {
  background-color: var(--color-grey-blue);
  padding: 0 20px;
  box-sizing: border-box;
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  .filter-wrapper {
    width: 100%;
    display: flex;
    max-height: 500px;
    transition: max-height 0.6s ease;
    -moz-transition: max-height 0.6s ease;
    -webkit-transition: max-height 0.6s ease;
    overflow: hidden;

    &.hidden {
      max-height: 0;
    }

    &.visible {
      overflow: visible;
    }

  }

  .filter {
    display: flex;
    align-items: start;
    text-align: left;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    margin-bottom: 20px;

    > div {
      display: flex;
      max-width: 60%;
      flex-basis: 20%;
      flex-grow: 1;
      flex-shrink: 0;

      > * {
        width: 100%;
      }
    }

    .filter-date-picker {
      max-width: 60%;
      flex-basis: 60%;
      gap: 20px;
      justify-content: space-between;

      > div {
        flex-basis: 50%;
      }
    }
  }

  .resetButton {
    width: auto !important;
    margin-left: auto;
    justify-content: end;
  }

  .filter-map {
    width: 100%;
    padding-top: 20px;
  }

  .filter-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin: 20px 0;
    gap: 20px;
  }

  .sort-button {
    width: auto !important;
  }

  .filter-button {
    position: relative;
    width: auto !important;
    cursor: pointer;

    &:before {
      font-family: var(--font-icons);
      font-size: var(--font-size-icon-s);
      line-height: 1;
      font-weight: normal;
      position: absolute;
      top: 0;
      left: 0;
    }

    span {
      color: var(--font-color-main);
      font-size: var(--font-size-main-text);
      line-height: var(--font-size-icon-s);
      padding-left: var(--font-size-icon-m);
    }

    &:hover {
      color: var(--color-red);
      span {
        color: var(--color-red);
      }
    }
  }
}

.news, .cooks {
  .section-inner > .content {
    --cols: 4;
    --gap: 15px;
    display: flex;
    flex-flow: row wrap;
    gap: var(--gap);
    width: 100%;
    padding: 2em 0;

    > * {
      display: flex;
      flex-basis: calc(100% / var(--cols) - var(--gap) / var(--cols) * (var(--cols) - 1));
      aspect-ratio: 1/1;
      flex-direction: column;
    }
  }
}

.partner {
  .content.highlight {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px 0;
    margin-top: 20px;
  }
}

@include media-min-width($breakpoint-l-deprecated) {
  .partner {
    .content.highlight {
      grid-template-columns: 400px auto;
      gap: 0 20px;
    }
  }
}

@include media-min-width($breakpoint-xl) {
  .form-container {
    .filter {
      .filter-date-picker {
        max-width: 50%;
        flex-basis: 50%;
      }
    }
  }
}

@include media-max-width($breakpoint-l) {
  .news, .cooks {
    .section-inner > .content {
      > * {
        --cols: 2;
      }
    }
  }

  .form-container {
    .filter {
      .filter-date-picker {
        max-width: 100%;
        flex-basis: 100%;
      }
    }
  }
}

@include media-max-width($breakpoint-s) {
  .news, .cooks {
    .section-inner > .content {
      > * {
        --cols: 1;
        aspect-ratio: 2/1;
      }
    }
  }

  .form-container {
    div {
      width: 100% !important;
    }

    .filter {
      flex-direction: column;
      flex-wrap: nowrap;

      div {
        flex: 0;
        max-width: 100% !important;
        flex-basis: 100%;
        width: 100%;
      }

      .filter-date-picker {
        flex-direction: column;
      }
    }
  }
}
